import { isNil, round } from 'lodash-es';

export function getLeaseDealsTrackingData(leaseDealsDataWithPhotos) {
  const defaultTrackingData = {
    match_total: leaseDealsDataWithPhotos.topDealsByModelCount,
    match_results: leaseDealsDataWithPhotos.deals.length,
    subaction_name: 'display_lease_deals',
    ts: Date.now(),
  };

  return leaseDealsDataWithPhotos.deals.reduce(
    (acc, { payment, paymentMedian, styleId, photo, showCta }, index) => {
      const belowAveragePayment = isNil(paymentMedian) ? '' : round(paymentMedian - payment);
      const photoType = photo?.href ? 'oem' : 'silhouette';
      const contactOptionValue = showCta ? 'dl_lead' : 'srp';

      acc.price = index === 0 ? `${payment}` : `${acc.price},${payment}`;
      acc.below_market = index === 0 ? `${belowAveragePayment}` : `${acc.below_market},${belowAveragePayment}`;
      acc.style_id_list = index === 0 ? `${styleId}` : `${acc.style_id_list},${styleId}`;
      acc.photo_type = index === 0 ? `${photoType}` : `${acc.photo_type},${photoType}`;
      acc.contact_options = index === 0 ? `${contactOptionValue}` : `${acc.contact_options},${contactOptionValue}`;
      acc.f_id_list = index === 0 ? '0' : `${acc.f_id_list},0`;

      return acc;
    },
    { ...defaultTrackingData }
  );
}
